<template>
	<div 
		:class="['job-overview-milestone-item', {'alert':alert}]" 
		:key="date.cache">
		<v-menu
			v-if="editable"
			ref="menu"
			v-model="menuState"
			:close-on-content-click="false"
			:return-value.sync="dateData"
			lazy full-width
			transition="slide-y-transition"
			min-width="290px">
			
			<div
				slot="activator"
				:class="['milestone']">
				<div :class="['milestone--title', {'is-estimate':isEstimate}]">
					<p class="">{{label}}</p>
				</div>
				<div class="milestone--body">
					<div class="milestone-date-container">
						<div class="body-2 month"><span>{{convertedDate.M}}</span></div>
						<div class="display-1 date"><span>{{convertedDate.D}}</span></div>
						<div class="body-2 year"><span>{{convertedDate.Y}}</span></div>
					</div>
				</div>
			</div>

			<v-date-picker 
				v-model="dateData"
				no-title scrollable
				:allowed-dates="getAllowedDates"
				:min="today">
				<v-spacer></v-spacer>
				<v-btn flat color="primary" @click="cancelData">Cancel</v-btn>
				<v-btn flat color="primary" @click="saveData">OK</v-btn>
			</v-date-picker>
		</v-menu>

		<div
			v-else
			:class="['milestone']">
			<div :class="['milestone--title', {'is-estimate':isEstimate}]">
				<p class="">{{label}}</p>
			</div>
			<div class="milestone--body">
				<div class="milestone-date-container">
					<div class="body-2 month">{{convertedDate.M}}</div>
					<div class="display-1 date">{{convertedDate.D}}</div>
					<div class="body-2 year">{{convertedDate.Y}}</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import dayjs from 'dayjs'

	import { mapState } from 'vuex'

	import * as VDatePicker from 'vuetify/es5/components/VDatePicker';
	
	export default {
		name: 'job-overview-milestone-item',

		components: {
			...VDatePicker
		},

		props: {
			date: {
				type: Object,
				required: false,
				default: null
			},
			label: {
				type: String,
				default: '--'
			},
			editable: {
				type: Boolean,
				default: false
			},
			prop: {
				type: String,
				default: null
			},
			approved: {
				type: Boolean,
				required: false,
				default: true
			},
			alert: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		data:() => ({
			dateData: null,
			menuState: null,
			convertedDate: { Y:null, M:null, D:null },
			monthsData: ["Jan", "Feb", "Mar", "Apr",
						"May", "Jun", "Jul", "Aug",
						"Sept", "Oct", "Nov", "Dec"]
		}),

		computed: {
			...mapState({
				blackoutDates: state => state.properties.orgBlackoutDates
			}),

			isEstimate() {
				return !this.approved && this.label !== 'Submit'
			},

			today() { return dayjs().format('YYYY-MM-DD') },
		},

		mounted() {
			this.dateData = (this.date.type === 'date') ? this.date.data.split(' ')[0] : this.date.data
		},	

		methods: {
			convertDate() {
				let d = this.dateData

				if (!this.approved && this.label !== 'Submit') {
					this.convertedDate = (this.label === 'Approval') ? {Y:``, M:`Pending`, D:`-`} : {Y:`Days`, M:`Approval`, D:`+${d}`}
					return
				}
				
				if ( typeof d == 'string' ) d = d.split(' ')[0].split('-')

				let Y = ( d.Y) ? d.Y : d[0]
				let M = ( d.M ) ? d.M : this.monthsData[parseInt(d[1])-1]
				let D = ( d.D ) ? d.D : d[2]

				this.convertedDate = { Y:Y, M:M, D:D }
			},

			getAllowedDates(val) {
				let blackout = this.blackoutDates.indexOf(val) === -1
				return ([5, 6].includes(new Date(val).getDay())) ? false : blackout
			},

			saveData() {
				this.$refs.menu.save(this.dateData)

				let d = dayjs(this.dateData).format('YYYY-MM-DD HH:mm:ss')
				this.$emit('input', { [this.prop]:d })
			},

			cancelData() {
				this.menuState = false
			}
		},

		watch: {
			dateData: {
				deep: true,
				handler() {
					this.convertDate()
				}
			}
		}
	}
</script>